
export type NewsCategoryKey = 'company' | 'industry' | 'media' | 'product';

export interface NewsItem {
  id: number;
  slug: string;
  title: string;
  excerpt: string;
  date: string;
  category: string;
  categoryKey: NewsCategoryKey;
  author: string;
  readTime: string;
  views: number;
  tags: string[];
}

export const NEWS_ITEMS: NewsItem[] = [
  {
    id: 1,
    slug: 'ququ-launch',
    title: '蛐蛐 QuQu 关系管家正式上线',
    excerpt: '面向个人用户的 AI 关系图谱工具，帮助梳理人脉、记录互动、发现关键连接。现已开放下载体验。',
    date: '2025-11-15',
    category: '产品发布',
    categoryKey: 'product',
    author: '产品团队',
    readTime: '4分钟',
    views: 1860,
    tags: ['QuQu', 'ToC', '关系图谱'],
  },
  {
    id: 2,
    slug: 'salary-reward-app-store',
    title: '薪资奖励官 App Store 上架',
    excerpt: '抬腕即看的实时计薪工具，支持 Apple Watch 与 iPhone 联动，让收入变化一目了然。',
    date: '2025-10-08',
    category: '产品发布',
    categoryKey: 'product',
    author: '产品团队',
    readTime: '3分钟',
    views: 2340,
    tags: ['薪资奖励官', 'Apple Watch', 'ToC'],
  },
  {
    id: 3,
    slug: 'sales-agent-beta',
    title: '销售智能体开启企业内测',
    excerpt: '面向本地企业的 AI 销售助手，覆盖线索跟进、话术建议与客户画像，助力销售团队提效。',
    date: '2025-09-20',
    category: '产品更新',
    categoryKey: 'company',
    author: '企业产品组',
    readTime: '5分钟',
    views: 1520,
    tags: ['销售智能体', 'ToB', 'AI'],
  },
  {
    id: 4,
    slug: 'product-matrix-strategy',
    title: 'AI 原生产品矩阵：从 ToC 到 ToB 的双轨战略',
    excerpt: '三米云科技坚持自研路线，以真实场景驱动产品迭代，构建可持续的产品组合而非概念堆砌。',
    date: '2025-08-12',
    category: '行业洞察',
    categoryKey: 'industry',
    author: '创始团队',
    readTime: '6分钟',
    views: 980,
    tags: ['战略', '产品矩阵', 'AI'],
  },
  {
    id: 5,
    slug: 'ranking-miniprogram',
    title: '排名小程序助力团队激励新玩法',
    excerpt: '「谁是黑马」排名小程序为团队提供可视化竞技排名，适用于销售竞赛与绩效激励场景。',
    date: '2025-07-28',
    category: '产品更新',
    categoryKey: 'product',
    author: '企业产品组',
    readTime: '4分钟',
    views: 1120,
    tags: ['排名小程序', '团队激励', 'ToB'],
  },
  {
    id: 6,
    slug: 'company-founded',
    title: '三米云科技完成公司注册，正式启动产品研发',
    excerpt: '三米云（上海）科技有限公司于 2025 年 4 月成立，总部设于上海，聚焦自研移动应用与企业智能化工具。',
    date: '2025-04-18',
    category: '公司动态',
    categoryKey: 'company',
    author: '公司公告',
    readTime: '2分钟',
    views: 3200,
    tags: ['公司成立', '上海', '创业'],
  },
];

/* 封面与色相已由 CategoryBannerCard 内的程序化封面接管，这里只保留导航语义 */
export const NEWS_CATEGORY_BANNERS = [
  { title: '公司新闻', link: '/news?cat=company' },
  { title: '行业前瞻', link: '/news?cat=industry' },
  { title: '媒体报道', link: '/news?cat=media' },
];

export const CATEGORY_FILTER_MAP: Record<string, NewsCategoryKey[]> = {
  company: ['company', 'product'],
  industry: ['industry'],
  media: ['media'],
};
